import NewButton from './NewButton'

export default NewButton
